import { __extends, __values } from "tslib";
import * as React from 'react';
import { XInputGroup } from "./XInputGroup";
import { XInputGroupItem } from "./XInputGroupItem";
import { ensureEnum, brushToString, stringToBrush, ensureBool, initializePropertiesFromCss, NamePatcher, isValidProp, toSpinal, getModifiedProps } from "igniteui-react-core";
import { ReactRenderer, PortalManager } from "igniteui-react-core";
import { IgrXInputGroupInputCollection } from './igr-x-input-group-input-collection';
import { CollectionAdapter } from "igniteui-react-core";
import { NotifyCollectionChangedAction } from "igniteui-react-core";
import { ContentChildrenManager } from "igniteui-react-core";
import { InputGroupDisplayType_$type } from './InputGroupDisplayType';
import { CornerRadius } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
var IgrXInputGroup = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrXInputGroup, _super);
    function IgrXInputGroup(props) {
        var _this = _super.call(this, props) || this;
        _this._wrapper = null;
        _this.contentInputs = [];
        /**
        * The style mappings actually present in the treemap. Do not directly modify this array.
        * This array's contents can be modified by causing React to reproject the child content.
        * Or adding and removing ranges from the manual ranges collection on the ranges property.
        */
        _this.actualInputs = [];
        _this._inputs = null;
        _this._inputsAdapter = null;
        _this._implementation = null;
        _this.__p = null;
        _this._hasUserValues = new Set();
        _this._stylingContainer = null;
        _this._stylingParent = null;
        _this._inStyling = false;
        if (_this._styling) {
            NamePatcher.ensureStylablePatched(Object.getPrototypeOf(_this));
        }
        _this._contentChildrenManager = new ContentChildrenManager(function (ch) { return ch.props.name || ch.key || ch.props.id; }, function (ch) { return ch.name || ch.key || ch.id; }, function () { return _this._updateContentChildren(); });
        _this._implementation = _this.createImplementation();
        _this._implementation.externalObject = _this;
        _this._getMainRef = _this._getMainRef.bind(_this);
        var container;
        if (document) {
            container = document.createElement("div");
        }
        var root;
        root = container;
        if (container != null) {
            root = container;
        }
        _this.requestRender = _this.requestRender.bind(_this);
        _this._portalManager = new PortalManager("inputContent", _this.requestRender);
        var ren = new ReactRenderer(root, document, true, {}, _this._portalManager);
        _this._wrapper = ren;
        _this._container = _this._wrapper.rootWrapper;
        _this._container.setStyleProperty("display", "inline-block");
        var inputGroup = _this.i;
        _this._inputGroup = inputGroup;
        _this._inputsAdapter = new CollectionAdapter(_this.contentInputs, _this.i.inputs, _this.actualInputs, function (c) { return c.i; }, function (i) {
            if (_this._container && _this._container.getNativeElement().parentElement) {
                i._styling(_this._container.getNativeElement(), _this, _this);
            }
        }, function (i) { });
        inputGroup.provideContainer(ren);
        if (props) {
            _this.initializeProperties();
        }
        return _this;
    }
    IgrXInputGroup.prototype._getMainRef = function (ref) {
        var _this = this;
        this._elRef = ref;
        if (this._elRef) {
            var mut = new MutationObserver(function (list) {
                var e_1, _a;
                try {
                    for (var list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                        var mutation = list_1_1.value;
                        if (mutation.type == 'childList') {
                            _this.i.onChildrenMutated();
                        }
                    }
                }
                catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                }
                finally {
                    try {
                        if (list_1_1 && !list_1_1.done && (_a = list_1.return))
                            _a.call(list_1);
                    }
                    finally {
                        if (e_1)
                            throw e_1.error;
                    }
                }
            });
            mut.observe(this._elRef, {
                childList: true,
                subtree: true
            });
        }
    };
    IgrXInputGroup.prototype._updateContentChildren = function () {
        this.contentInputs.length = 0;
        var contentChildrenActual = this._contentChildrenManager.contentChildrenActual;
        for (var i = 0; i < contentChildrenActual.length; i++) {
            if ((XInputGroupItem.$type).isAssignableFrom(contentChildrenActual[i].i.$type)) {
                this.contentInputs.push(contentChildrenActual[i]);
            }
        }
        if (this._inputsAdapter !== null) {
            this._inputsAdapter.notifyContentChanged();
        }
    };
    Object.defineProperty(IgrXInputGroup.prototype, "inputs", {
        /**
         * A collection of manually added style mappings for the treemap.
        */
        get: function () {
            var _this = this;
            if (this._inputs === null) {
                var coll = new IgrXInputGroupInputCollection();
                var inner = coll._innerColl;
                inner.addListener(function (sender, e) {
                    switch (e.action) {
                        case NotifyCollectionChangedAction.Add:
                            _this._inputsAdapter.insertManualItem(e.newStartingIndex, e.newItems.item(0));
                            break;
                        case NotifyCollectionChangedAction.Remove:
                            _this._inputsAdapter.removeManualItemAt(e.oldStartingIndex);
                            break;
                        case NotifyCollectionChangedAction.Replace:
                            _this._inputsAdapter.removeManualItemAt(e.oldStartingIndex);
                            _this._inputsAdapter.insertManualItem(e.newStartingIndex, e.newItems.item(0));
                            break;
                        case NotifyCollectionChangedAction.Reset:
                            _this._inputsAdapter.clearManualItems();
                            break;
                    }
                });
                this._inputs = coll;
            }
            return this._inputs;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.render = function () {
        var children = this._contentChildrenManager.getChildren(this.props.children);
        this._portalManager.onRender(children);
        var div = React.createElement("div", {
            className: "ig-x-input-group igr-x-input-group",
            ref: this._getMainRef,
            children: children
        });
        return div;
    };
    IgrXInputGroup.prototype.requestRender = function () {
        if (this._initialized) {
            this.setState({});
        }
    };
    //private _getLabelPortal(element: DomWrapper, portalCallback: (portal: DomPortal) => void): void {
    //    this._portalManager.getPortal(element, "TemplateContent", portalCallback);
    //}
    IgrXInputGroup.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var e_2, _a;
        var mod = getModifiedProps(this.props, nextProps);
        try {
            for (var _b = __values(Object.keys(mod)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = mod[p];
                }
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        return true;
    };
    IgrXInputGroup.prototype.initializeProperties = function () {
        var e_3, _a;
        try {
            for (var _b = __values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (isValidProp(this, p)) {
                    this[p] = this.props[p];
                }
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
    };
    // supports angular themes or custom properties set in CSS
    IgrXInputGroup.prototype.updateStyle = function () {
        this._styling(this._elRef, this);
    };
    IgrXInputGroup.prototype.componentWillUnmount = function () {
        this._inputGroup.destroy();
        this._wrapper.destroy();
    };
    IgrXInputGroup.prototype.componentDidMount = function () {
        this._elRef.appendChild(this._container.getNativeElement());
        this.initializeContent();
    };
    IgrXInputGroup.prototype.initializeContent = function () {
        this._styling(this._container.getNativeElement(), this);
        this.updateStyle();
        this.i.ensureShift();
    };
    IgrXInputGroup.prototype.createImplementation = function () {
        return new XInputGroup();
    };
    Object.defineProperty(IgrXInputGroup.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "displayType", {
        /**
     * Gets or sets the display style to use for the button.
    */
        get: function () {
            return this.i.k;
        },
        set: function (v) {
            this.i.k = ensureEnum(InputGroupDisplayType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "density", {
        /**
         * Gets or sets the display density to use for the input group.
        */
        get: function () {
            return this.i.h;
        },
        set: function (v) {
            this.i.h = ensureEnum(ControlDisplayDensity_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualDensity", {
        /**
         * Gets the actual display density to use for the input group.
        */
        get: function () {
            return this.i.g;
        },
        set: function (v) {
            this.i.g = ensureEnum(ControlDisplayDensity_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "baseTheme", {
        /**
         * Gets or sets the base built in theme to use for the label.
        */
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = ensureEnum(BaseControlTheme_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "inputHasValue", {
        get: function () {
            return this.i.af;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualBorderColor", {
        /**
         * Gets the actual item background color.
        */
        get: function () {
            return brushToString(this.i.ot);
        },
        set: function (v) {
            this.i.ot = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualFocusBorderColor", {
        /**
         * Gets the actual item border color.
        */
        get: function () {
            return brushToString(this.i.ou);
        },
        set: function (v) {
            this.i.ou = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualBorderWidth", {
        /**
         * Gets the actual item border width.
        */
        get: function () {
            return this.i.ca;
        },
        set: function (v) {
            this.i.ca = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualFocusBorderWidth", {
        /**
         * Gets the actual item border width.
        */
        get: function () {
            return this.i.cb;
        },
        set: function (v) {
            this.i.cb = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualCornerRadiusBottomRight", {
        get: function () {
            return this.i.m0 ? this.i.m0.b : NaN;
        },
        set: function (v) {
            this.ensureActualCornerRadius();
            this.i.m0.b = +v;
            this.i.m0 = this.i.m0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualCornerRadiusBottomLeft", {
        get: function () {
            return this.i.m0 ? this.i.m0.a : NaN;
        },
        set: function (v) {
            this.ensureActualCornerRadius();
            this.i.m0.a = +v;
            this.i.m0 = this.i.m0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualCornerRadiusTopLeft", {
        get: function () {
            return this.i.m0 ? this.i.m0.c : NaN;
        },
        set: function (v) {
            this.ensureActualCornerRadius();
            this.i.m0.c = +v;
            this.i.m0 = this.i.m0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualCornerRadiusTopRight", {
        get: function () {
            return this.i.m0 ? this.i.m0.d : NaN;
        },
        set: function (v) {
            this.ensureActualCornerRadius();
            this.i.m0.d = +v;
            this.i.m0 = this.i.m0;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureActualCornerRadius = function () {
        if (this.i.m0) {
            return;
        }
        this.i.m0 = new CornerRadius(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "actualContentPaddingBottom", {
        get: function () {
            return this.i.tg ? this.i.tg.b : NaN;
        },
        set: function (v) {
            this.ensureActualContentPadding();
            this.i.tg.b = +v;
            this.i.tg = this.i.tg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualContentPaddingLeft", {
        get: function () {
            return this.i.tg ? this.i.tg.c : NaN;
        },
        set: function (v) {
            this.ensureActualContentPadding();
            this.i.tg.c = +v;
            this.i.tg = this.i.tg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualContentPaddingRight", {
        get: function () {
            return this.i.tg ? this.i.tg.d : NaN;
        },
        set: function (v) {
            this.ensureActualContentPadding();
            this.i.tg.d = +v;
            this.i.tg = this.i.tg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualContentPaddingTop", {
        get: function () {
            return this.i.tg ? this.i.tg.e : NaN;
        },
        set: function (v) {
            this.ensureActualContentPadding();
            this.i.tg.e = +v;
            this.i.tg = this.i.tg;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureActualContentPadding = function () {
        if (this.i.tg) {
            return;
        }
        this.i.tg = new Thickness(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "actualUnderlineWidth", {
        /**
         * Gets the actual width to use for the underline element.
        */
        get: function () {
            return this.i.cj;
        },
        set: function (v) {
            this.i.cj = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualUnderlineRippleWidth", {
        /**
         * Gets the actual width to use for the underline element.
        */
        get: function () {
            return this.i.ci;
        },
        set: function (v) {
            this.i.ci = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualHoverUnderlineWidth", {
        /**
         * Gets the width to use for the underline element when hovered.
        */
        get: function () {
            return this.i.cf;
        },
        set: function (v) {
            this.i.cf = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualUnderlineColor", {
        /**
         * Gets the actual color to use for the underline element.
        */
        get: function () {
            return brushToString(this.i.ox);
        },
        set: function (v) {
            this.i.ox = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualUnderlineRippleColor", {
        /**
         * Gets the actual color to use for the underline ripple element.
        */
        get: function () {
            return brushToString(this.i.oy);
        },
        set: function (v) {
            this.i.oy = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualHoverUnderlineColor", {
        /**
         * Gets the actual color to use for the underline element.
        */
        get: function () {
            return brushToString(this.i.ow);
        },
        set: function (v) {
            this.i.ow = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualFocusUnderlineColor", {
        /**
         * Gets the actual color to use for the underline element when focused.
        */
        get: function () {
            return brushToString(this.i.ov);
        },
        set: function (v) {
            this.i.ov = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualUnderlineOpacity", {
        /**
         * Gets the actual opacity to use for the underline element.
        */
        get: function () {
            return this.i.cg;
        },
        set: function (v) {
            this.i.cg = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualHoverUnderlineOpacity", {
        /**
         * Gets the actual opacity to use for the underline element when hovered.
        */
        get: function () {
            return this.i.ce;
        },
        set: function (v) {
            this.i.ce = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualFocusUnderlineOpacity", {
        /**
         * Gets the actual opacity to use for the underline element when focused.
        */
        get: function () {
            return this.i.cc;
        },
        set: function (v) {
            this.i.cc = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualFocusUnderlineRippleOpacity", {
        /**
         * Gets the actual opacity to use for the underline ripple element when focused.
        */
        get: function () {
            return this.i.cd;
        },
        set: function (v) {
            this.i.cd = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualUnderlineRippleOpacity", {
        /**
         * Gets the actual opacity to use for the underline ripple element.
        */
        get: function () {
            return this.i.ch;
        },
        set: function (v) {
            this.i.ch = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualBackgroundColor", {
        /**
         * Gets the actual opacity to use for the underline ripple element.
        */
        get: function () {
            return brushToString(this.i.os);
        },
        set: function (v) {
            this.i.os = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group.
        */
        get: function () {
            return this.i.cu;
        },
        set: function (v) {
            this.i.cu = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "focusBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when focused.
        */
        get: function () {
            return this.i.hc;
        },
        set: function (v) {
            this.i.hc = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderColor", {
        /**
         * Gets or sets the color to use the border of the input group.
        */
        get: function () {
            return brushToString(this.i.o0);
        },
        set: function (v) {
            this.i.o0 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "cornerRadiusBottomRight", {
        get: function () {
            return this.i.m4 ? this.i.m4.b : NaN;
        },
        set: function (v) {
            this.ensureCornerRadius();
            this.i.m4.b = +v;
            this.i.m4 = this.i.m4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "cornerRadiusBottomLeft", {
        get: function () {
            return this.i.m4 ? this.i.m4.a : NaN;
        },
        set: function (v) {
            this.ensureCornerRadius();
            this.i.m4.a = +v;
            this.i.m4 = this.i.m4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "cornerRadiusTopLeft", {
        get: function () {
            return this.i.m4 ? this.i.m4.c : NaN;
        },
        set: function (v) {
            this.ensureCornerRadius();
            this.i.m4.c = +v;
            this.i.m4 = this.i.m4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "cornerRadiusTopRight", {
        get: function () {
            return this.i.m4 ? this.i.m4.d : NaN;
        },
        set: function (v) {
            this.ensureCornerRadius();
            this.i.m4.d = +v;
            this.i.m4 = this.i.m4;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureCornerRadius = function () {
        if (this.i.m4) {
            return;
        }
        this.i.m4 = new CornerRadius(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "contentPaddingBottom", {
        get: function () {
            return this.i.tk ? this.i.tk.b : NaN;
        },
        set: function (v) {
            this.ensureContentPadding();
            this.i.tk.b = +v;
            this.i.tk = this.i.tk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "contentPaddingLeft", {
        get: function () {
            return this.i.tk ? this.i.tk.c : NaN;
        },
        set: function (v) {
            this.ensureContentPadding();
            this.i.tk.c = +v;
            this.i.tk = this.i.tk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "contentPaddingRight", {
        get: function () {
            return this.i.tk ? this.i.tk.d : NaN;
        },
        set: function (v) {
            this.ensureContentPadding();
            this.i.tk.d = +v;
            this.i.tk = this.i.tk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "contentPaddingTop", {
        get: function () {
            return this.i.tk ? this.i.tk.e : NaN;
        },
        set: function (v) {
            this.ensureContentPadding();
            this.i.tk.e = +v;
            this.i.tk = this.i.tk;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureContentPadding = function () {
        if (this.i.tk) {
            return;
        }
        this.i.tk = new Thickness(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "underlineWidth", {
        /**
         * Gets or sets the width to use for the underline element.
        */
        get: function () {
            return this.i.h4;
        },
        set: function (v) {
            this.i.h4 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "underlineRippleWidth", {
        /**
         * Gets or sets the width to use for the underline element.
        */
        get: function () {
            return this.i.h3;
        },
        set: function (v) {
            this.i.h3 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "hoverUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when hovered.
        */
        get: function () {
            return this.i.hg;
        },
        set: function (v) {
            this.i.hg = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "underlineColor", {
        /**
         * Gets or sets the color to use for the underline element.
        */
        get: function () {
            return brushToString(this.i.s8);
        },
        set: function (v) {
            this.i.s8 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "underlineRippleColor", {
        /**
         * Gets or sets the color to use for the underline ripple element.
        */
        get: function () {
            return brushToString(this.i.s9);
        },
        set: function (v) {
            this.i.s9 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "hoverUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element.
        */
        get: function () {
            return brushToString(this.i.st);
        },
        set: function (v) {
            this.i.st = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "focusUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element.
        */
        get: function () {
            return brushToString(this.i.ss);
        },
        set: function (v) {
            this.i.ss = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "underlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element.
        */
        get: function () {
            return this.i.h1;
        },
        set: function (v) {
            this.i.h1 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "hoverUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element.
        */
        get: function () {
            return this.i.hf;
        },
        set: function (v) {
            this.i.hf = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "focusUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element.
        */
        get: function () {
            return this.i.hd;
        },
        set: function (v) {
            this.i.hd = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "focusUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when focused.
        */
        get: function () {
            return this.i.he;
        },
        set: function (v) {
            this.i.he = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "underlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element.
        */
        get: function () {
            return this.i.h2;
        },
        set: function (v) {
            this.i.h2 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "backgroundColor", {
        /**
         * Gets or sets the background color to use for the input group.
        */
        get: function () {
            return brushToString(this.i.oz);
        },
        set: function (v) {
            this.i.oz = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when using type line.
        */
        get: function () {
            return this.i.hh;
        },
        set: function (v) {
            this.i.hh = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeFocusBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when focused when type is line.
        */
        get: function () {
            return this.i.hi;
        },
        set: function (v) {
            this.i.hi = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeFocusBorderColor", {
        /**
         * Gets or sets the focus color to use the border of the input group when type is line.
        */
        get: function () {
            return brushToString(this.i.sw);
        },
        set: function (v) {
            this.i.sw = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeBorderColor", {
        /**
         * Gets or sets the color to use the border of the input group when type is line.
        */
        get: function () {
            return brushToString(this.i.sv);
        },
        set: function (v) {
            this.i.sv = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeCornerRadiusBottomRight", {
        get: function () {
            return this.i.nk ? this.i.nk.b : NaN;
        },
        set: function (v) {
            this.ensureLineTypeCornerRadius();
            this.i.nk.b = +v;
            this.i.nk = this.i.nk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeCornerRadiusBottomLeft", {
        get: function () {
            return this.i.nk ? this.i.nk.a : NaN;
        },
        set: function (v) {
            this.ensureLineTypeCornerRadius();
            this.i.nk.a = +v;
            this.i.nk = this.i.nk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeCornerRadiusTopLeft", {
        get: function () {
            return this.i.nk ? this.i.nk.c : NaN;
        },
        set: function (v) {
            this.ensureLineTypeCornerRadius();
            this.i.nk.c = +v;
            this.i.nk = this.i.nk;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeCornerRadiusTopRight", {
        get: function () {
            return this.i.nk ? this.i.nk.d : NaN;
        },
        set: function (v) {
            this.ensureLineTypeCornerRadius();
            this.i.nk.d = +v;
            this.i.nk = this.i.nk;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureLineTypeCornerRadius = function () {
        if (this.i.nk) {
            return;
        }
        this.i.nk = new CornerRadius(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeContentPaddingBottom", {
        get: function () {
            return this.i.t0 ? this.i.t0.b : NaN;
        },
        set: function (v) {
            this.ensureLineTypeContentPadding();
            this.i.t0.b = +v;
            this.i.t0 = this.i.t0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeContentPaddingLeft", {
        get: function () {
            return this.i.t0 ? this.i.t0.c : NaN;
        },
        set: function (v) {
            this.ensureLineTypeContentPadding();
            this.i.t0.c = +v;
            this.i.t0 = this.i.t0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeContentPaddingRight", {
        get: function () {
            return this.i.t0 ? this.i.t0.d : NaN;
        },
        set: function (v) {
            this.ensureLineTypeContentPadding();
            this.i.t0.d = +v;
            this.i.t0 = this.i.t0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeContentPaddingTop", {
        get: function () {
            return this.i.t0 ? this.i.t0.e : NaN;
        },
        set: function (v) {
            this.ensureLineTypeContentPadding();
            this.i.t0.e = +v;
            this.i.t0 = this.i.t0;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureLineTypeContentPadding = function () {
        if (this.i.t0) {
            return;
        }
        this.i.t0 = new Thickness(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is line.
        */
        get: function () {
            return this.i.hq;
        },
        set: function (v) {
            this.i.hq = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeUnderlineRippleWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is line.
        */
        get: function () {
            return this.i.hp;
        },
        set: function (v) {
            this.i.hp = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeHoverUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when hovered when type is line.
        */
        get: function () {
            return this.i.hm;
        },
        set: function (v) {
            this.i.hm = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is line.
        */
        get: function () {
            return brushToString(this.i.sz);
        },
        set: function (v) {
            this.i.sz = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeUnderlineRippleColor", {
        /**
         * Gets or sets the color to use for the underline ripple element when type is line.
        */
        get: function () {
            return brushToString(this.i.s0);
        },
        set: function (v) {
            this.i.s0 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeHoverUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is line.
        */
        get: function () {
            return brushToString(this.i.sy);
        },
        set: function (v) {
            this.i.sy = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeFocusUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is line.
        */
        get: function () {
            return brushToString(this.i.sx);
        },
        set: function (v) {
            this.i.sx = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is line.
        */
        get: function () {
            return this.i.hn;
        },
        set: function (v) {
            this.i.hn = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeHoverUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is line.
        */
        get: function () {
            return this.i.hl;
        },
        set: function (v) {
            this.i.hl = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeFocusUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is line.
        */
        get: function () {
            return this.i.hj;
        },
        set: function (v) {
            this.i.hj = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeFocusUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when focused when type is line.
        */
        get: function () {
            return this.i.hk;
        },
        set: function (v) {
            this.i.hk = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when type is line.
        */
        get: function () {
            return this.i.ho;
        },
        set: function (v) {
            this.i.ho = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "lineTypeBackgroundColor", {
        /**
         * Gets or sets the background color to use for the input group when type is line.
        */
        get: function () {
            return brushToString(this.i.su);
        },
        set: function (v) {
            this.i.su = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when using type line.
        */
        get: function () {
            return this.i.cv;
        },
        set: function (v) {
            this.i.cv = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeFocusBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when focused when type is box.
        */
        get: function () {
            return this.i.cw;
        },
        set: function (v) {
            this.i.cw = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeFocusBorderColor", {
        /**
         * Gets or sets the focus color to use the border of the input group when type is box.
        */
        get: function () {
            return brushToString(this.i.pa);
        },
        set: function (v) {
            this.i.pa = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeBorderColor", {
        /**
         * Gets or sets the color to use the border of the input group when type is box.
        */
        get: function () {
            return brushToString(this.i.o9);
        },
        set: function (v) {
            this.i.o9 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeCornerRadiusBottomRight", {
        get: function () {
            return this.i.m2 ? this.i.m2.b : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeCornerRadius();
            this.i.m2.b = +v;
            this.i.m2 = this.i.m2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeCornerRadiusBottomLeft", {
        get: function () {
            return this.i.m2 ? this.i.m2.a : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeCornerRadius();
            this.i.m2.a = +v;
            this.i.m2 = this.i.m2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeCornerRadiusTopLeft", {
        get: function () {
            return this.i.m2 ? this.i.m2.c : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeCornerRadius();
            this.i.m2.c = +v;
            this.i.m2 = this.i.m2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeCornerRadiusTopRight", {
        get: function () {
            return this.i.m2 ? this.i.m2.d : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeCornerRadius();
            this.i.m2.d = +v;
            this.i.m2 = this.i.m2;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureBoxTypeCornerRadius = function () {
        if (this.i.m2) {
            return;
        }
        this.i.m2 = new CornerRadius(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeContentPaddingBottom", {
        get: function () {
            return this.i.ti ? this.i.ti.b : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeContentPadding();
            this.i.ti.b = +v;
            this.i.ti = this.i.ti;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeContentPaddingLeft", {
        get: function () {
            return this.i.ti ? this.i.ti.c : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeContentPadding();
            this.i.ti.c = +v;
            this.i.ti = this.i.ti;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeContentPaddingRight", {
        get: function () {
            return this.i.ti ? this.i.ti.d : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeContentPadding();
            this.i.ti.d = +v;
            this.i.ti = this.i.ti;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeContentPaddingTop", {
        get: function () {
            return this.i.ti ? this.i.ti.e : NaN;
        },
        set: function (v) {
            this.ensureBoxTypeContentPadding();
            this.i.ti.e = +v;
            this.i.ti = this.i.ti;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureBoxTypeContentPadding = function () {
        if (this.i.ti) {
            return;
        }
        this.i.ti = new Thickness(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is box.
        */
        get: function () {
            return this.i.c4;
        },
        set: function (v) {
            this.i.c4 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeUnderlineRippleWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is box.
        */
        get: function () {
            return this.i.c3;
        },
        set: function (v) {
            this.i.c3 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeHoverUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when hovered when type is box.
        */
        get: function () {
            return this.i.c0;
        },
        set: function (v) {
            this.i.c0 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is box.
        */
        get: function () {
            return brushToString(this.i.pd);
        },
        set: function (v) {
            this.i.pd = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeUnderlineRippleColor", {
        /**
         * Gets or sets the color to use for the underline ripple element when type is box.
        */
        get: function () {
            return brushToString(this.i.pe);
        },
        set: function (v) {
            this.i.pe = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeHoverUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is box.
        */
        get: function () {
            return brushToString(this.i.pc);
        },
        set: function (v) {
            this.i.pc = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeFocusUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is box.
        */
        get: function () {
            return brushToString(this.i.pb);
        },
        set: function (v) {
            this.i.pb = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is box.
        */
        get: function () {
            return this.i.c1;
        },
        set: function (v) {
            this.i.c1 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeHoverUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is box.
        */
        get: function () {
            return this.i.cz;
        },
        set: function (v) {
            this.i.cz = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeFocusUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is box.
        */
        get: function () {
            return this.i.cx;
        },
        set: function (v) {
            this.i.cx = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeFocusUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when focused when type is box.
        */
        get: function () {
            return this.i.cy;
        },
        set: function (v) {
            this.i.cy = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when type is box.
        */
        get: function () {
            return this.i.c2;
        },
        set: function (v) {
            this.i.c2 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "boxTypeBackgroundColor", {
        /**
         * Gets or sets the background color to use for the input group when type is box.
        */
        get: function () {
            return brushToString(this.i.o8);
        },
        set: function (v) {
            this.i.o8 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when using type line.
        */
        get: function () {
            return this.i.ck;
        },
        set: function (v) {
            this.i.ck = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeFocusBorderWidth", {
        /**
         * Gets or sets the border width to use for the border of the item group when focused when type is border.
        */
        get: function () {
            return this.i.cl;
        },
        set: function (v) {
            this.i.cl = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeFocusBorderColor", {
        /**
         * Gets or sets the focus color to use the border of the input group when type is border.
        */
        get: function () {
            return brushToString(this.i.o3);
        },
        set: function (v) {
            this.i.o3 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeBorderColor", {
        /**
         * Gets or sets the color to use the border of the input group when type is border.
        */
        get: function () {
            return brushToString(this.i.o2);
        },
        set: function (v) {
            this.i.o2 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeCornerRadiusBottomRight", {
        get: function () {
            return this.i.m1 ? this.i.m1.b : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeCornerRadius();
            this.i.m1.b = +v;
            this.i.m1 = this.i.m1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeCornerRadiusBottomLeft", {
        get: function () {
            return this.i.m1 ? this.i.m1.a : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeCornerRadius();
            this.i.m1.a = +v;
            this.i.m1 = this.i.m1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeCornerRadiusTopLeft", {
        get: function () {
            return this.i.m1 ? this.i.m1.c : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeCornerRadius();
            this.i.m1.c = +v;
            this.i.m1 = this.i.m1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeCornerRadiusTopRight", {
        get: function () {
            return this.i.m1 ? this.i.m1.d : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeCornerRadius();
            this.i.m1.d = +v;
            this.i.m1 = this.i.m1;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureBorderTypeCornerRadius = function () {
        if (this.i.m1) {
            return;
        }
        this.i.m1 = new CornerRadius(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeContentPaddingBottom", {
        get: function () {
            return this.i.th ? this.i.th.b : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeContentPadding();
            this.i.th.b = +v;
            this.i.th = this.i.th;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeContentPaddingLeft", {
        get: function () {
            return this.i.th ? this.i.th.c : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeContentPadding();
            this.i.th.c = +v;
            this.i.th = this.i.th;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeContentPaddingRight", {
        get: function () {
            return this.i.th ? this.i.th.d : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeContentPadding();
            this.i.th.d = +v;
            this.i.th = this.i.th;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeContentPaddingTop", {
        get: function () {
            return this.i.th ? this.i.th.e : NaN;
        },
        set: function (v) {
            this.ensureBorderTypeContentPadding();
            this.i.th.e = +v;
            this.i.th = this.i.th;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureBorderTypeContentPadding = function () {
        if (this.i.th) {
            return;
        }
        this.i.th = new Thickness(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is border.
        */
        get: function () {
            return this.i.ct;
        },
        set: function (v) {
            this.i.ct = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeUnderlineRippleWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is border.
        */
        get: function () {
            return this.i.cs;
        },
        set: function (v) {
            this.i.cs = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeHoverUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when hovered when type is border.
        */
        get: function () {
            return this.i.cp;
        },
        set: function (v) {
            this.i.cp = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is border.
        */
        get: function () {
            return brushToString(this.i.o6);
        },
        set: function (v) {
            this.i.o6 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeUnderlineRippleColor", {
        /**
         * Gets or sets the color to use for the underline ripple element when type is border.
        */
        get: function () {
            return brushToString(this.i.o7);
        },
        set: function (v) {
            this.i.o7 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeHoverUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is border.
        */
        get: function () {
            return brushToString(this.i.o5);
        },
        set: function (v) {
            this.i.o5 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeFocusUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is border.
        */
        get: function () {
            return brushToString(this.i.o4);
        },
        set: function (v) {
            this.i.o4 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is border.
        */
        get: function () {
            return this.i.cq;
        },
        set: function (v) {
            this.i.cq = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeHoverUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is border.
        */
        get: function () {
            return this.i.co;
        },
        set: function (v) {
            this.i.co = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeFocusUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is border.
        */
        get: function () {
            return this.i.cm;
        },
        set: function (v) {
            this.i.cm = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeFocusUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when focused when type is border.
        */
        get: function () {
            return this.i.cn;
        },
        set: function (v) {
            this.i.cn = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when type is border.
        */
        get: function () {
            return this.i.cr;
        },
        set: function (v) {
            this.i.cr = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "borderTypeBackgroundColor", {
        /**
         * Gets or sets the background color to use for the input group when type is border.
        */
        get: function () {
            return brushToString(this.i.o1);
        },
        set: function (v) {
            this.i.o1 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeBorderWidth", {
        /**
         * Gets or sets the search width to use for the border of the item group when using type line.
        */
        get: function () {
            return this.i.hr;
        },
        set: function (v) {
            this.i.hr = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeFocusBorderWidth", {
        /**
         * Gets or sets the search width to use for the border of the item group when focused when type is search.
        */
        get: function () {
            return this.i.hs;
        },
        set: function (v) {
            this.i.hs = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeFocusBorderColor", {
        /**
         * Gets or sets the focus color to use the search of the input group when type is search.
        */
        get: function () {
            return brushToString(this.i.s3);
        },
        set: function (v) {
            this.i.s3 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeBorderColor", {
        /**
         * Gets or sets the color to use the search of the input group when type is search.
        */
        get: function () {
            return brushToString(this.i.s2);
        },
        set: function (v) {
            this.i.s2 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeCornerRadiusBottomRight", {
        get: function () {
            return this.i.nl ? this.i.nl.b : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeCornerRadius();
            this.i.nl.b = +v;
            this.i.nl = this.i.nl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeCornerRadiusBottomLeft", {
        get: function () {
            return this.i.nl ? this.i.nl.a : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeCornerRadius();
            this.i.nl.a = +v;
            this.i.nl = this.i.nl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeCornerRadiusTopLeft", {
        get: function () {
            return this.i.nl ? this.i.nl.c : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeCornerRadius();
            this.i.nl.c = +v;
            this.i.nl = this.i.nl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeCornerRadiusTopRight", {
        get: function () {
            return this.i.nl ? this.i.nl.d : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeCornerRadius();
            this.i.nl.d = +v;
            this.i.nl = this.i.nl;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureSearchTypeCornerRadius = function () {
        if (this.i.nl) {
            return;
        }
        this.i.nl = new CornerRadius(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeContentPaddingBottom", {
        get: function () {
            return this.i.t1 ? this.i.t1.b : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeContentPadding();
            this.i.t1.b = +v;
            this.i.t1 = this.i.t1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeContentPaddingLeft", {
        get: function () {
            return this.i.t1 ? this.i.t1.c : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeContentPadding();
            this.i.t1.c = +v;
            this.i.t1 = this.i.t1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeContentPaddingRight", {
        get: function () {
            return this.i.t1 ? this.i.t1.d : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeContentPadding();
            this.i.t1.d = +v;
            this.i.t1 = this.i.t1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeContentPaddingTop", {
        get: function () {
            return this.i.t1 ? this.i.t1.e : NaN;
        },
        set: function (v) {
            this.ensureSearchTypeContentPadding();
            this.i.t1.e = +v;
            this.i.t1 = this.i.t1;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.ensureSearchTypeContentPadding = function () {
        if (this.i.t1) {
            return;
        }
        this.i.t1 = new Thickness(2);
    };
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is search.
        */
        get: function () {
            return this.i.h0;
        },
        set: function (v) {
            this.i.h0 = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeUnderlineRippleWidth", {
        /**
         * Gets or sets the width to use for the underline element when type is search.
        */
        get: function () {
            return this.i.hz;
        },
        set: function (v) {
            this.i.hz = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeHoverUnderlineWidth", {
        /**
         * Gets or sets the width to use for the underline element when hovered when type is search.
        */
        get: function () {
            return this.i.hw;
        },
        set: function (v) {
            this.i.hw = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is search.
        */
        get: function () {
            return brushToString(this.i.s6);
        },
        set: function (v) {
            this.i.s6 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeUnderlineRippleColor", {
        /**
         * Gets or sets the color to use for the underline ripple element when type is search.
        */
        get: function () {
            return brushToString(this.i.s7);
        },
        set: function (v) {
            this.i.s7 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeHoverUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is search.
        */
        get: function () {
            return brushToString(this.i.s5);
        },
        set: function (v) {
            this.i.s5 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeFocusUnderlineColor", {
        /**
         * Gets or sets the color to use for the underline element when type is search.
        */
        get: function () {
            return brushToString(this.i.s4);
        },
        set: function (v) {
            this.i.s4 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is search.
        */
        get: function () {
            return this.i.hx;
        },
        set: function (v) {
            this.i.hx = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeHoverUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is search.
        */
        get: function () {
            return this.i.hv;
        },
        set: function (v) {
            this.i.hv = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeFocusUnderlineOpacity", {
        /**
         * Gets or sets the color to use for the underline element when type is search.
        */
        get: function () {
            return this.i.ht;
        },
        set: function (v) {
            this.i.ht = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeFocusUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when focused when type is search.
        */
        get: function () {
            return this.i.hu;
        },
        set: function (v) {
            this.i.hu = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeUnderlineRippleOpacity", {
        /**
         * Gets or sets the opacity to use for the underline ripple element when type is search.
        */
        get: function () {
            return this.i.hy;
        },
        set: function (v) {
            this.i.hy = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "searchTypeBackgroundColor", {
        /**
         * Gets or sets the background color to use for the input group when type is search.
        */
        get: function () {
            return brushToString(this.i.s1);
        },
        set: function (v) {
            this.i.s1 = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "isExpanded", {
        /**
         * Gets or sets whether the input group is expanded or not.
        */
        get: function () {
            return this.i.ah;
        },
        set: function (v) {
            this.i.ah = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "isHovered", {
        /**
         * Gets or sets whether the input group is hovered or not.
        */
        get: function () {
            return this.i.aj;
        },
        set: function (v) {
            this.i.aj = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "isFocused", {
        /**
         * Gets or sets whether the input group is hovered or not.
        */
        get: function () {
            return this.i.ai;
        },
        set: function (v) {
            this.i.ai = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "actualIsExpanded", {
        /**
         * Gets or sets whether the input group is expanded or not.
        */
        get: function () {
            return this.i.ac;
        },
        set: function (v) {
            this.i.ac = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "focusBorderColor", {
        /**
         * Gets or sets the color to use the hovered background of the inputs in the group.
        */
        get: function () {
            return brushToString(this.i.sr);
        },
        set: function (v) {
            this.i.sr = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "id", {
        /**
         * Gets or sets the id to use for the checkbox.
        */
        get: function () {
            return this.i.ki;
        },
        set: function (v) {
            this.i.ki = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrXInputGroup.prototype, "disabled", {
        /**
         * Gets or sets whether the checkbox is disabled.
        */
        get: function () {
            return this.i.disabled;
        },
        set: function (v) {
            this.i.disabled = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.findByName = function (name) {
        if (this.inputs != null && this.inputs.findByName && this.inputs.findByName(name)) {
            return this.inputs.findByName(name);
        }
        return null;
    };
    Object.defineProperty(IgrXInputGroup.prototype, "hasUserValues", {
        get: function () {
            return this._hasUserValues;
        },
        enumerable: false,
        configurable: true
    });
    IgrXInputGroup.prototype.__m = function (propertyName) {
        if (!this._inStyling) {
            this._hasUserValues.add(propertyName);
        }
    };
    IgrXInputGroup.prototype._styling = function (container, component, parent) {
        if (this._inStyling) {
            return;
        }
        this._inStyling = true;
        this._stylingContainer = container;
        this._stylingParent = component;
        var genericPrefix = "";
        var typeName = this.i.$type.name;
        if (typeName.indexOf("Xam") === 0) {
            typeName = typeName.substring(3);
        }
        genericPrefix = toSpinal("XInputGroup");
        var additionalPrefixes = [];
        var prefix = toSpinal(typeName);
        additionalPrefixes.push(prefix + "-");
        var b = this.i.$type.baseType;
        while (b && b.name != "Object" &&
            b.name != "Base" &&
            b.name != "Control" &&
            b.Name != "DependencyObject" &&
            b.Name != "FrameworkElement") {
            typeName = b.name;
            if (typeName.indexOf("Xam") === 0) {
                typeName = typeName.substring(3);
            }
            var basePrefix = toSpinal(typeName);
            additionalPrefixes.push(basePrefix + "-");
            b = b.baseType;
        }
        if (parent) {
            var parentTypeName = parent.i.$type.name;
            if (parentTypeName.indexOf("Xam") === 0) {
                parentTypeName = parentTypeName.substring(3);
            }
            var parentPrefix = toSpinal(parentTypeName);
            additionalPrefixes.push(parentPrefix + "-" + genericPrefix + "-");
            additionalPrefixes.push(parentPrefix + "-" + prefix + "-");
        }
        initializePropertiesFromCss(container, this, genericPrefix + "-", this.hasUserValues, false, additionalPrefixes);
        if (this._otherStyling) {
            this._otherStyling(container, component, parent);
        }
        this._inStyling = false;
    };
    IgrXInputGroup.prototype.onDetachedFromUI = function () {
        this.i.onDetachedFromUI();
    };
    IgrXInputGroup.prototype.onAttachedToUI = function () {
        this.i.onAttachedToUI();
    };
    /**
     * Exports visual information about the current state of the grid.
    
    */
    IgrXInputGroup.prototype.exportVisualModel = function () {
        var iv = this.i.ia();
        return (iv);
    };
    /**
     * Returns a serialized copy of the exported visual model
    
    */
    IgrXInputGroup.prototype.exportSerializedVisualModel = function () {
        var iv = this.i.j9();
        return (iv);
    };
    return IgrXInputGroup;
}(React.Component));
export { IgrXInputGroup };
//# sourceMappingURL=igr-x-input-group.js.map
